import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { decorators } from "@orange-marmalade/paginate-this";
import { parse } from "query-string";
import { Map } from "immutable";
import {
  registerSearch,
  unregisterSearch
} from "APP_ROOT/middleware/syncSearchStateWithUrl";

class Search extends React.Component {
  componentWillMount() {
    window.addEventListener("keydown", this.keyStroke);
  }

  componentDidMount() {
    const { search, syncWithUrl } = this.props;
    if (syncWithUrl) {
      this.initializeSearchFromUrl();
      registerSearch(search);
    }
  }

  componentWillUnmount() {
    unregisterSearch(this.props.search);
    window.removeEventListener("keydown", this.keyStroke);
  }

  keyStroke = evt => {
    const { paginator, pageActions } = this.props;

    const page = paginator.get("page");

    const totalPages = Math.ceil(
      paginator.get("totalCount") / paginator.get("pageSize")
    );

    if (page && page > 1 && evt.ctrlKey && evt.key === "l") {
      pageActions.prev();
      evt.preventDefault();
    }

    if (page && page < totalPages && evt.ctrlKey && evt.key === "r") {
      pageActions.next();
      evt.preventDefault();
    }
  };

  initializeSearchFromUrl() {
    const { dispatch, search } = this.props;
    const { filter, limit, page, ...filters } = parse(location.search);

    if (limit !== undefined) {
      dispatch(search.setLimit(limit));
    }
    if (Object.keys(filters).length > 0) {
      dispatch(search.setFilters(filters));
    }
    if (filter !== undefined) {
      dispatch(search.setFilter("filter", filter));
    }
    if (page !== undefined) {
      dispatch(search.setPage(page));
    }
  }

  render() {
    return this.props.children({
      ...this.props
    });
  }
}

Search.propTypes = {
  search: PropTypes.shape({}),
  syncWithUrl: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  paginator: PropTypes.instanceOf(Map).isRequired,
  pageActions: PropTypes.shape({
    next: PropTypes.func.isRequired,
    prev: PropTypes.func.isRequired
  }).isRequired
};

export default function SearchComponent({
  search,
  syncWithUrl,
  children,
  ...rest
}) {
  const WithPaginator = decorators.decorate(Search, ({ paginator }) => ({
    paginator,
    children,
    search,
    syncWithUrl,
    ...rest
  }));

  const Tabulated = connect()(decorators.tabulate(WithPaginator));

  return <Tabulated listId={search.listId} />;
}

SearchComponent.propTypes = {
  search: PropTypes.shape({}),
  syncWithUrl: PropTypes.bool,
  children: PropTypes.func.isRequired
};

export const SearchPropTypes = PropTypes.shape({
  pageActions: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  results: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired
});



// WEBPACK FOOTER //
// ./app/modules/shared/components/Search/Search.jsx